module.exports = __webpack_public_path__ + "img/fourfoot.fce68a69.jpg";